import{ Modal, FC, useMemo, useEffect} from 'external/react'

import ModalAcceptCancelFooter from 'components/ModalAcceptCancelFooter'
import { clearedEditUser } from 'types/context/parent'
import useParent from 'context/parent-context/hook'
import useFormValidation, { validators } from 'utilities/form-validation'
import EditUserForm from './EditUserForm'
import { userService } from 'services/user.service'
import { notifySuccess } from 'components/Notify'

const {createRequiredFieldValidation, createEmailValidation} = validators

const editUserValidations = {
	first_name: [createRequiredFieldValidation('first_name')],
	last_name: [createRequiredFieldValidation('last_name')],
	email: [createRequiredFieldValidation('email'), createEmailValidation('email')],
	password: [createRequiredFieldValidation('password')]
}


const EditUserModal: FC = () => {

	const {update, state: { modals}, params: {role}, editUser} = useParent()
	
	const [errors, validate, resetValidations] = useFormValidation(editUserValidations);
	const roleName = useMemo(() => role === 'student' ? 'estudiante' : 'tutor', [role])

	function handleClose() {
		resetValidations()
		update({modals: {editUser: {open: {$set: false}, user: {$shallow: clearedEditUser}}}})
	}

	async function handleUserSave() {
		if (!validate(modals.editUser.user, true)) return
		editUser(modals.editUser.user)
		notifySuccess('Usuario actualizado exitosamente.')
		handleClose()
	}

	useEffect(() => { validate(modals.editUser.user, false) }, [modals.editUser.user])


    return (
			<Modal show={modals.editUser.open} onHide={handleClose} size='lg' centered >
				<Modal.Header closeButton>
					<h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }} >Editar {roleName}</h5>
				</Modal.Header>
				<Modal.Body>
					<EditUserForm errors={errors}/>
				</Modal.Body>
				<ModalAcceptCancelFooter onCancel={handleClose} onAccept={handleUserSave}/>
			</Modal>
        )
}


export {EditUserModal as default}